var map = {
	"./1.png": 7241,
	"./nes-15-6.png": 5981,
	"./news-1.1.1.png": 2885,
	"./news-1.1.png": 879,
	"./news-1.2.png": 3687,
	"./news-10-1.png": 9046,
	"./news-10-2.png": 2754,
	"./news-10-3.png": 6147,
	"./news-10-4.png": 5794,
	"./news-10.png": 7351,
	"./news-11-1.png": 3381,
	"./news-11-2.png": 2816,
	"./news-11-3.png": 7304,
	"./news-11-4.png": 9728,
	"./news-11-5.png": 6093,
	"./news-11.png": 6371,
	"./news-12-1.png": 6977,
	"./news-12-2.png": 8472,
	"./news-12.png": 4971,
	"./news-13.png": 602,
	"./news-14-1.jpg": 3917,
	"./news-14.png": 9814,
	"./news-15-1.png": 4245,
	"./news-15-2.png": 4459,
	"./news-15-3.png": 1665,
	"./news-15-4.png": 3608,
	"./news-15-5.png": 8586,
	"./news-15-6.png": 7725,
	"./news-16-1.png": 8829,
	"./news-16-2.png": 4555,
	"./news-16-3.png": 3092,
	"./news-16.png": 813,
	"./news-17-1.png": 5002,
	"./news-17.png": 9167,
	"./news-18-1.png": 7231,
	"./news-18-2.png": 1142,
	"./news-18.png": 5066,
	"./news-19-1.jpg": 1957,
	"./news-19-2.png": 7587,
	"./news-19.png": 7900,
	"./news-2.png": 2100,
	"./news-20.jpg": 9608,
	"./news-21-1.png": 3692,
	"./news-21-2.png": 4098,
	"./news-21.png": 3284,
	"./news-22.png": 7100,
	"./news-23-1.png": 2508,
	"./news-23.png": 1438,
	"./news-24-1.png": 5825,
	"./news-24.png": 6518,
	"./news-25-1.png": 1801,
	"./news-25-2.png": 7353,
	"./news-25-3.png": 5504,
	"./news-25-4.png": 161,
	"./news-25.png": 7524,
	"./news-26-1.png": 157,
	"./news-26-2.png": 5332,
	"./news-26-3.png": 3951,
	"./news-26.png": 618,
	"./news-27-1.png": 8864,
	"./news-27-2.png": 3435,
	"./news-27-3.png": 5238,
	"./news-27-4.png": 223,
	"./news-27.png": 5679,
	"./news-28-1.jpg": 2188,
	"./news-28-2.png": 7016,
	"./news-28-3.png": 9501,
	"./news-28.png": 7216,
	"./news-3.1.png": 7126,
	"./news-3.png": 2543,
	"./news-4.2.png": 3517,
	"./news-4.3.png": 7710,
	"./news-4.png": 1173,
	"./news-5.1.png": 9836,
	"./news-5.png": 9675,
	"./news-6.png": 3806,
	"./news-7.png": 2364,
	"./news-8.gif": 6529,
	"./news-8.png": 3485,
	"./news-9-1.png": 2746,
	"./news-9-2.png": 4298,
	"./news-9-3.png": 2066,
	"./news-9.png": 9209,
	"./news_15_background.png": 293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1256;